import React from "react";
import { Link } from "react-router-dom";

function StoreCard({ card }) {
  return (
    <>
      <div class="col-12 col-md-6 col-lg-4 dx-isotope-grid-item theme">
        <div class="dx-portfolio-item dx-block-decorated">
          <div class="dx-portfolio-item-image">
            <div
              class="dx-portfolio-item-overlay"
              style={{ backgroundColor: "rgba(27, 27, 27, 0.8)" }}
            >
              <Link
                to="/store"
                class="dx-btn dx-btn-md dx-btn-transparent-style-2 m-10"
              >
                {card.demo}
              </Link>
              <Link
                to="/store"
                class="dx-btn dx-btn-md dx-btn-transparent-style-2 m-10"
              >
                {card.buy}
              </Link>
            </div>
            <img src={card.image} alt="" />
          </div>
          <Link to="/store" class="dx-portfolio-item-info">
            <span class="dx-portfolio-item-title">{card.text}</span>
            <span class="dx-portfolio-item-price">{card.price}</span>
          </Link>
        </div>
      </div>
    </>
  );
}

export default StoreCard;
